import { createFileRoute } from '@tanstack/react-router'

import { Seo } from '@/components/common/seo'
import { Hero } from '@/features/home/hero'
import { Highlights } from '@/features/home/highlights'
import { CtaSection } from '@/features/home/cta-section'
import { homeAcquireCta } from '@/features/home/home-content'

export const Route = createFileRoute('/')({
  component: IndexRoute,
})

function IndexRoute() {
  return (
    <>
      <Seo />
      <Hero />
      <Highlights />
      <CtaSection
        title={homeAcquireCta.title}
        description={homeAcquireCta.description}
        ctaLabel={homeAcquireCta.ctaLabel}
        ctaHref={homeAcquireCta.ctaHref}
      />
    </>
  )
}
